import { Injectable, EventEmitter } from '@angular/core';
import {
  Router,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError,
  ActivatedRoute,
} from '@angular/router';
import { RoutePages } from '../enum/route-pages';
import { RouteUtil } from '../util/route-util';
import { SignatureRoutePages } from '../modules/signature/enum/signature-route-pages';
import { AuthUtilService } from './auth-util.service';
import { AuthService } from './auth.service';
import { ApiUrlUtil } from '../util/api-url-util';

@Injectable({
  providedIn: 'root',
})
export class RouteService {
  navigationEnd = new EventEmitter();

  private urlSignatureAccessToken = RoutePages.Signature.concat('/').concat(
    SignatureRoutePages.AccessToken
  );

  private urlSignatureInitial = RoutePages.Signature.concat('/').concat(
    SignatureRoutePages.Initial
  );

  private urlSignatureDenied = RoutePages.Signature.concat('/').concat(
    SignatureRoutePages.Denied
  );

  private urlEnvelopeAlreadySigned = RoutePages.Signature.concat('/').concat(
    SignatureRoutePages.alreadySigned
  );

  private urlEnvelopeAlreadySignedConcluded = RoutePages.Signature.concat(
    '/'
  ).concat(SignatureRoutePages.alreadySignedConcluded);

  private urlEnvelopeDocumentRejected = RoutePages.Signature.concat(
    '/'
  ).concat(SignatureRoutePages.Paused);

  private urlEnvelopeResponsibleAlreadyFilled = RoutePages.Signature.concat(
    '/'
  ).concat(SignatureRoutePages.ResponsibleAlreadyFilled);

  private urlVerificationPortal = RoutePages.VerificationPortal;

  private currRoute = RoutePages.Root;

  constructor(
    private authService: AuthService,
    private authUtilService: AuthUtilService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    router.events.subscribe((navigation) => {
      this.checkRouterEvent(navigation);
    });
  }

  checkRouterEvent(routerEvent: any): void {
    switch (routerEvent.constructor) {
      case NavigationStart:
      case NavigationCancel:
      case NavigationError:
        break;
      case NavigationEnd:
        this.currRoute = RouteUtil.currentRoute(this.getCleanUrl(), RoutePages);
        const routeData = this.getActiveRouteData();
        this.navigationEnd.emit({ routeData, activeRoute: this.currRoute, fullUrl: this.router.url });
        break;
    }
  }

  goTo(routePath: RoutePages): void {
    this.router.navigate(['/' + routePath]);
  }

  getCurrentRoute(): RoutePages {
    return this.currRoute;
  }

  logoutAndGoToSuiteRoot(): void {
    ApiUrlUtil.goToSuiteRoot();
  }

  logout() {
    this.authService.revokeToken();
    this.authService.stopRefreshTokenTimer();
    this.authUtilService.setUser(null);
    this.authUtilService.setUserSign(null);
    this.authUtilService.clearJwtToken();
    ApiUrlUtil.goToSuiteLogin();
  }

  redirectToAccessToken(): void {
    this.router.navigate([this.urlSignatureAccessToken]);
  }

  redirectToErrorPage(): void {
    this.router.navigate([this.urlSignatureInitial]);
  }

  redirectToDeniedPage(): void {
    this.router.navigate([this.urlSignatureDenied]);
  }

  redirectToPageAlreadySigned(): void {
    this.router.navigate([this.urlEnvelopeAlreadySigned]);
  }

  redirectToPageAlreadySignedConcluded(): void {
    this.router.navigate([this.urlEnvelopeAlreadySignedConcluded]);
  }

  redirectToPageDocumentRejected(): void {
    this.router.navigate([this.urlEnvelopeDocumentRejected]);
  }

  redirectToPageResponsibleAlreadyFilled(): void {
    this.router.navigate([this.urlEnvelopeResponsibleAlreadyFilled]);
  }

  redirectToVerificationPortal(verificarionCode: string): void {
    this.router.navigate([
      this.urlVerificationPortal.concat('/') + verificarionCode,
    ]);
  }

  private getCleanUrl() {
    const fragmentsUrl = this.router.url.split('/');
    if (fragmentsUrl.length > 0) {
      return fragmentsUrl[1];
    } else {
      RoutePages[''];
    }
  }

  private getActiveRouteData() {
    return this.route.root.firstChild
      ? this.route.root.firstChild.snapshot.data
      : undefined;
  }
}
